module.exports = "<app-navbar></app-navbar>\n<app-userregister></app-userregister>"